var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#13CFE8",
    d: "M16.75 10c.416 0 .75-.334.75-.75v-4.5a.75.75 0 0 0-.75-.75.75.75 0 0 0-.75.75v2.503l-.625-.734A6.98 6.98 0 0 0 10 4a7 7 0 1 0 4.2 12.6.75.75 0 0 0 .15-1.05.75.75 0 0 0-1.05-.15 5.5 5.5 0 1 1 .925-7.919l.003.006.863 1.013H12.25a.75.75 0 0 0-.75.75c0 .416.334.75.75.75z"
  })));
};
export default SvgRefresh;